export const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "Servizio eccellente! Ha risolto un problema elettrico complesso in pochissimo tempo. Professionale e prezzi onesti.",
    author: "Marco R.",
    location: "Centro Storico"
  },
  {
    id: 2,
    rating: 5,
    text: "Finalmente un vero ciapinaro! Ha montato tutta la cucina IKEA in una giornata, perfetto in ogni dettaglio.",
    author: "Laura M.",
    location: "San Donato"
  },
  {
    id: 3,
    rating: 5,
    text: "Perdita d'acqua nel weekend, è arrivato in 30 minuti e ha risolto tutto. Disponibilità e competenza al top!",
    author: "Giuseppe T.",
    location: "Casalecchio"
  }
];